import { Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import htmlReactParser from 'html-react-parser';
import TabPanel from './TabPanel';
import { ReactComponent as Launch } from '../../assets/FTE1.svg';

export default function Tab1(props: { value: number }) {
  const { value } = props;
  const { t } = useTranslation();

  return (
    <TabPanel value={value} index={0}>
      <Stack display="flex" flexDirection="row">
        <Typography>{htmlReactParser(t('content.tutorial.tab1'))}</Typography>
        <Launch />
      </Stack>
    </TabPanel>
  );
}
